export default "__VITE_ASSET__BpZR0Rut__"